import attrToBool from './utils/attrToBool';

const ajaxFeed = $ => {
	const $feeds = $( '[data-ajax="feed"]' );
	const $loader = $( '<div class="loader"><i class="loading-icon fas fa-spinner fa-pulse"></i></div>' );

	// Gets parent element
	const getFeed = $el => {
		return $el.parents( '[data-ajax="feed"]' );
	};

	// Gets feed form
	const getForm = $feed => {
		return $feed.find( '[data-ajax="form"]' );
	};

	// Gets feed wrapper to clear and add feed markup
	const getFeedWrapper = $feed => {
		return $feed.find( '[data-ajax="content"]' );
	};

	// Gets pagination location to prevent page jumping
	const getPaginationPos = $feed => {
		const $pagination = $feed.find( '.pagination' );
		return $pagination.get( 0 ).offsetTop;
	};

	// Get page value from form
	const getPage = $form => {
		return parseInt( $form.attr( 'data-ajax-page' ), 10 );
	};

	// Takes array value and returns url encoded string of values
	// Returns null if empty array
	// Used to set url
	const setArrayQueryVal = val => {
		if ( ! val.length ) {
			return null;
		}

		return encodeURIComponent( val.join( ',' ) );
	};

	// Gets value from hidden form field
	const getHiddenValue = $input => {
		const dataType = $input.attr( 'data-type' );
		const value = $input.val();

		// Return array value
		if ( dataType === 'array' ) {
			return value.split( ',' );
		}

		// Return bool value
		if ( dataType === 'bool' ) {
			return attrToBool( value );
		}

		// Return string value
		return value;
	};

	// Gets value from radio form field
	const getRadioValue = ( $form, name ) => {
		const $radio = $form.find( `input[type="radio"][name="${ name }"]:checked` );
		return $radio.val() ? $radio.val() : null;
	};

	// Gets value from checkbox form field
	const getCheckboxValue = ( $form, name ) => {
		const $checkboxes = $form.find( `input[type="checkbox"][name="${ name }"]` );

		// Multiple checkboxes with same name return array
		if ( $checkboxes.length > 1 ) {
			return getCheckboxArrayVal( $checkboxes );
		}

		const value = $checkboxes.val();
		const isBool = value === 'true' || value === 'false' ? true : false;

		// if not bool return value or null
		if ( ! isBool ) {
			return $checkboxes.is( ':checked' ) ? value : null;
		}

		// if bool return bool value
		const boolValue = attrToBool( value );
		return $checkboxes.is( ':checked' ) ? boolValue : ! boolValue;
	};

	// Gets array value from checkboxes with same name
	const getCheckboxArrayVal = $checkboxes => {
		const values = [];

		$checkboxes.each( ( i, el ) => {
			const $this = $( el );

			if ( $this.is( ':checked' ) ) {
				values.push( $this.val() );
			}
		} );

		return values;
	};

	// Generic function to get field values of defined input types
	// Used to get form values to send to rest api
	// Used to get form values for URL query string
	const getValues = ( $form, inputTypes ) => {
		const values = {};
		const $filters = $form.find( inputTypes.toString() );

		$filters.each( ( i, el ) => {
			const $this = $( el );
			const name = $this.attr( 'name' );

			// Skip if we already have value
			// checkbox will have multiple
			if ( name in values ) {
				return;
			}

			if ( $this.prop( 'type' ) === 'hidden' ) {
				values[ name ] = getHiddenValue( $this );
				return;
			}

			if ( $this.prop( 'type' ) === 'checkbox' ) {
				values[ name ] = getCheckboxValue( $form, name );
				return;
			}

			if ( $this.prop( 'type' ) === 'radio' ) {
				values[ name ] = getRadioValue( $form, name );
				return;
			}

			values[ name ] = $this.val();
		} );

		return values;
	};

	// Get form values to send to rest api
	const getFormValues = $form => {
		const inputTypes = [
			'input[type="checkbox"]',
			'input[type="hidden"]',
			'input[type="radio"]',
			'input[type="search"]',
			'select'
		];

		const values = getValues( $form, inputTypes );
		return JSON.stringify( values );
	};

	// Gets form values for URL query string
	const getQueryString = $form => {
		const inputTypes = [
			'input[type="checkbox"]',
			'input[type="radio"]',
			'input[type="search"]',
			'select'
		];

		const values = getValues( $form, inputTypes );

		if ( $.isEmptyObject( values ) ) {
			return null;
		}

		return Object.keys( values ).reduce( ( acc, key ) => {
			let val = values[ key ];
			val = Array.isArray( val ) ? setArrayQueryVal( val ) : val;

			// Do not add key/val if empty array
			if ( ! val ) {
				return acc;
			}

			if ( val.indexOf( ' ' ) > -1 ) {
				val = encodeURIComponent( val );
			}

			const keyVal = `${ key }=${ val }`;
			return acc === '' ? `?${ keyVal }` : `${ acc }&${ keyVal }`;
		}, '' );
	};

	// Gets ajax params from form
	const getParams = $feed => {
		const $form = getForm( $feed );
		const url = $form.attr( 'action' );
		const template = $form.attr( 'data-ajax-template' );
		const ppp = $form.attr( 'data-ajax-ppp' );
		const page = getPage( $form );
		const values = getFormValues( $form );

		return {
			url,
			template,
			ppp: ppp ? parseInt( ppp, 10 ) : null,
			page,
			values
		};
	};

	// AJAX request
	const getData = ( url, requestParams ) => {
		return new Promise( ( resolve, reject ) => {
			$.ajax( {
				type: 'POST',
				url,
				data: {
					...requestParams
				},
				success: response => {
					return resolve( response );
				},
				error: response => {
					return reject( response );
				}
			} );
		} );
	};

	// Clears feed content and adds new markup
	const renderFeed = ( $feed, feed ) => {
		const $feedWraper = getFeedWrapper( $feed );

		// Remove feed contents
		$feedWraper.empty();

		// Add new content
		$feedWraper.append( feed );
	};

	// Clears pagination content and adds new markup
	const renderPagination = ( $feed, pagination ) => {
		const $feedFooter = $feed.find( '[data-ajax="footer"]' );
		const $currentPagination = $feedFooter.find( '[data-ajax="pagination"]' );

		// Remove events before removing elements
		if ( $currentPagination.length ) {
			$currentPagination.off( 'click', paginate );
		}

		// Remove pagination
		$feedFooter.empty();

		// Add new pagination
		$feedFooter.append( pagination );

		// Add new events
		const $pagination = $feedFooter.find( '[data-ajax="pagination"]' );
		$pagination.on( 'click', paginate );
	};

	// Formats <title> text to match WP naming
	const getUpdatedTitle = page => {
		const hasPages = page > 1 ? true : false;
		const title = document.title.split( ' – ' );
		const pageTitle = title[ 0 ];
		const siteTitle = title[ title.length - 1 ];
		const newTitle = hasPages ? `${ pageTitle } – Page ${ page } – ${ siteTitle }` : `${ pageTitle } – ${ siteTitle }`;
		return newTitle;
	};

	// Changes browser URL without adding to history
	// Updates page <title>
	const updateUrlAndTitle = $feed => {
		const $form = getForm( $feed );
		const page = getPage( $form );
		const hasPages = page > 1 ? true : false;
		const queryString = getQueryString( $form );
		const title = getUpdatedTitle( page );

		const { origin, pathname } = window.location;
		const pageIndex = pathname.indexOf( '/page/' );
		const urlContainsPage = pageIndex === -1 ? false : true;
		const baseUrl = urlContainsPage ? `${ origin }${ pathname.substring( 0, pageIndex ) }/` : `${ origin }${ pathname }`;

		let url = hasPages ? `${ baseUrl }page/${ page }/` : `${ baseUrl }`;
		url = queryString ? `${ url }${ queryString }` : url;

		document.title = title;
		window.history.replaceState( {}, title, url );
	};

	// Main feed function
	// Gets data and renders new feed and pagination
	// Updates URL
	const updateFeed = async $feed => {
		const $form = getForm( $feed );
		const updateUrl = attrToBool( $form.attr( 'data-ajax-update' ) );
		const $feedWraper = getFeedWrapper( $feed );

		// Add spinner
		$feedWraper.append( $loader );

		const {
			url,
			template,
			ppp,
			page,
			values
		} = getParams( $feed );

		const requestParams = {
			template,
			ppp,
			page,
			values
		};

		const data = await getData( url, requestParams );
		const { pagination, feed } = JSON.parse( data );

		renderFeed( $feed, feed );
		renderPagination( $feed, pagination );

		if ( updateUrl ) {
			updateUrlAndTitle( $feed );
		}

		// Needed for pagination not to shift on feed load
		$feed.trigger( 'feed.loaded' );
		$feed.off( 'feed.loaded' );
	};

	// On form submit actions
	const submit = e => {
		e.preventDefault();

		const $form = $( e.currentTarget );
		const $feed = getFeed( $form );

		// Reset back to first page when changing filters
		$form.attr( 'data-ajax-page', 1 );

		updateFeed( $feed );
	};

	// On paginate click actions
	const paginate = e => {
		e.preventDefault();

		const $btn = $( e.currentTarget );
		const $feed = getFeed( $btn );
		const $form = getForm( $feed );
		const newPage = $btn.attr( 'data-page' );

		$form.attr( 'data-ajax-page', newPage );

		// Keep pagination from shifting position on new feed
		const paginationBeforePosY = getPaginationPos( $feed );

		$feed.on( 'feed.loaded', () => {
			const paginationAfterPosY = getPaginationPos( $feed );
			const posDiff = paginationBeforePosY - paginationAfterPosY;
			window.scrollTo( 0, window.scrollY - posDiff );
		} );

		updateFeed( $feed );
	};

	// On checkbox change
	const updateCheckbox = ( $checkbox, $form ) => {
		const name = $checkbox.attr( 'name' );
		const value = $checkbox.val();
		const values = getCheckboxValue( $form, name );
		const $allCheckbox = $form.find( `input[type=checkbox][name=${ name }][value=all]` );

		// Only all is checked, do not remove check if clicked on
		if ( value === 'all' && ! $allCheckbox.is( ':checked' ) && ! values.length ) {
			$allCheckbox.prop( 'checked', true );
			return;
		}

		// Remove check from other checkboxes if clicking on all
		if ( value === 'all' && $allCheckbox.is( ':checked' ) && values.length ) {
			$form
				.find( `input[type=checkbox][name=${ name }]:not([value=all])` )
				.prop( 'checked', false );
		}

		// Remove check from all if other another check clicked
		if ( value !== 'all' && $allCheckbox.is( ':checked' ) ) {
			$allCheckbox.prop( 'checked', false );
		}

		// All checkboxs unchecked, add all checked
		if ( ! values.length ) {
			$allCheckbox.prop( 'checked', true );
		}
	};

	return {
		init() {
			if ( ! $feeds.length ) {
				return;
			}

			$feeds.each( ( i, el ) => {
				updateFeed( $( el ) );
			} );

			this.bind();
		},
		bind() {
			$feeds.each( ( i, el ) => {
				const $feed = $( el );
				const $form = getForm( $feed );
				$form.on( 'submit', submit );

				// Submit on select change
				$form.find( 'select' ).on( 'change', () => {
					$form.trigger( 'submit' );
				} );

				// Submit on radio change
				$form.find( 'input[type=radio]' ).on( 'change', () => {
					$form.trigger( 'submit' );
				} );

				// Submit on checkbox change
				// Clear 'all' input on checkbox change
				$form.find( 'input[type=checkbox]' ).on( 'change', e => {
					const $checkbox = $( e.currentTarget );
					const hasAllCheckbox = $form.find( 'input[type=checkbox][value="all"]' ).length > 0 ? true : false;

					if ( hasAllCheckbox ) {
						updateCheckbox( $checkbox, $form );
					}

					$form.trigger( 'submit' );
				} );
			} );
		}
	};
};

ajaxFeed( jQuery ).init();
